import {
  WealthProgramCreatePage,
  WealthProgramDetailPage,
  WealthProgramEditPage,
  WealthProgramListPage,
} from 'apps/wealth/components/programs/pages';
import {
  UserAssignmentsCreatePage,
  UserAssignmentsDetailPage,
  UserAssignmentsEditPage,
  UserAssignmentsListPage,
} from 'apps/wealth/components/user-assignments/pages';

const wealthRoutes = [
  // Programs
  { path: '/wealth/programs', element: <WealthProgramListPage /> },
  { path: '/wealth/programs/create', element: <WealthProgramCreatePage /> },
  { path: '/wealth/programs/:id', element: <WealthProgramDetailPage /> },
  { path: '/wealth/programs/:id/edit', element: <WealthProgramEditPage /> },

  // User assignments
  { path: '/wealth/user-assignments', element: <UserAssignmentsListPage /> },
  {
    path: '/wealth/user-assignments/create',
    element: <UserAssignmentsCreatePage />,
  },
  {
    path: '/wealth/user-assignments/:id',
    element: <UserAssignmentsDetailPage />,
  },
  {
    path: '/wealth/user-assignments/:id/edit',
    element: <UserAssignmentsEditPage />,
  },
];

export default wealthRoutes;
